<template>
    <DropDown
        class="!py-1 h-[50%]"
        :model-value="oPositionData_i.selectedInstrument"
        showOptionIcon
        @update:model-value="changeCoin"
        :options="aCoinOptions"
    >
        <template v-slot:header>
            <span class="flex">
                <img
                    class="w-[20px] h-[20px]"
                    v-if="selectedCoin?.icon" 
                    :src="selectedCoin?.icon" 
                />
                <span class="font-semibold">
                    &nbsp;{{ selectedCoin?.name }}
                </span>
            </span>
        </template>
        <DropDownItem
            :current-value="oPositionData_i.selectedInstrument"
            :value="oCoin.value"
            @click="() => changeCoin(oCoin)"
            v-for="oCoin of aCoinOptions"
            :key="oCoin.value"
        >
            <img
                class="w-[20px] h-[20px]"
                v-if="oCoin.icon" 
                :src="oCoin.icon" 
            />
            <span class=""> 
                &nbsp;{{ oCoin.name }} 
            </span>
        </DropDownItem>
    </DropDown>
</template>

<script setup lang> 
import { aCoinList } from '@/pages/casino/futuresGame/ts/wavesData'; 
import {
    oPositionData_i, 
    oPositionCenter_yt, 
} from '@/pages/casino/futuresGame/ts/wavesControlCenter'; 
import { cryptoIcons } from '@/utils/cryptos'

const { coin } = useFuturesStore()

const {t: $tFn} = useNuxtApp().$i18n; 
const oMyPositionCenter = oPositionCenter_yt(); 

// ↓ 币种列表 
const aCoinOptions = computed(()=>{
    const arr01 = [{
        value: '',
        name: $tFn('waves.AllInstruments'), 
        icon: '', // 有意使用空值 
    }];
    coin.forEach(key=>{
        const obj  = {
            name: key,
            value: `${key}_USDT`,
            optionIcon: cryptoIcons[key],
            icon: cryptoIcons[key],
        }
        arr01.push(obj);
    })
    // aCoinList.forEach((oCoin) => {
    //     const obj = {
    //         ...oCoin,
    //         value: oCoin.pairName,
    //         optionIcon: oCoin.icon,
    //     };
    //     arr01.push(obj); 
    // });
    return arr01
});

// ↓ 被选中的币种 
const selectedCoin = computed(() =>{
    const oResult = aCoinOptions.value.find((coin) => {
        return coin.value == oPositionData_i.selectedInstrument; 
    });
    return oResult; // || {};
});


// ↓ 切换币种
function changeCoin(oCoin) {
    console.log("执行切换币种：", oCoin); 
    oMyPositionCenter.setSelectedInstrument(oCoin.value); 
}


</script>

<style scoped lang="scss">

</style>
